"use client";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { motion } from "framer-motion";
import { useLocale } from "next-intl";
import { useGetAbout } from "@/hooks/main-hooks";

export default function Who() {
  const t = useTranslations("AboutPage");
  const locale = useLocale();
  const isAr = locale === "ar";

  const { data: about } = useGetAbout();
  const storyDesc =
    (isAr ? about?.whoWeAre?.descriptionAr : about?.whoWeAre?.descriptionEn) ||
    t("aboutDes");

  return (
    <section className="relative py-24 bg-white overflow-hidden">
      <div className="absolute top-10 left-0 w-full overflow-hidden pointer-events-none opacity-[0.02] select-none">
        <h2 className="text-[20vw] font-black leading-none">
          {isAr ? "الصناعة" : "Industry"}
        </h2>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div
          className={`flex flex-col lg:flex-row gap-16 items-center ${
            isAr ? "lg:flex-row-reverse" : ""
          }`}
        >
          <div className="w-full lg:w-1/2">
            <div className={`relative`}>
              <h5 className="text-sm font-black text-brand-blue mb-6 uppercase tracking-tight">
                {isAr ? "قصتنا" : "Our Story"}
              </h5>

              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-brand-navy mb-6 leading-tight">
                {!isAr
                  ? "Building the Future with Precision & Passion"
                  : "نبني المستقبل بالدقة والشغف"}
              </h3>

              <div className="space-y-6 text-brand-navy/70 leading-relaxed text-lg">
                <p className="font-medium">{storyDesc}</p>
                <p className="font-medium">{t("aboutDes2")}</p>
                <div className="h-px w-full bg-brand-navy/5" />
                <p className="text-base">{t("who_wer_are_description_2")}</p>
              </div>

              <div className="mt-10 flex items-center gap-4">
                <div className="flex -space-x-2">
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className="w-8 h-8 rounded-full bg-brand-navy border-2 border-white flex items-center justify-center text-[10px] text-white font-bold"
                    >
                      {i}
                    </div>
                  ))}
                </div>
                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-brand-navy/40">
                  {locale === "en"
                    ? "Industry Leaders Since 2004"
                    : "رواد الصناعة منذ 2004"}
                </span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 relative">
            <motion.div
              initial={{ opacity: 0, scale: 0.9, rotate: isAr ? -2 : 2 }}
              whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
              transition={{ duration: 0.8 }}
              className="relative aspect-4/3 z-10 overflow-hidden shadow-[0_50px_100px_-20px_rgba(0,0,0,0.2)]"
            >
              <Image
                src="/zaR8Loay.jpeg"
                alt="About Us"
                fill
                className="object-cover transition-transform duration-700 hover:scale-110"
              />
              <div className="absolute inset-0 bg-brand-navy/10 group-hover:bg-transparent transition-colors" />
            </motion.div>

            <div
              className={`absolute -bottom-6 -right-6 w-full h-full border-2 border-brand-creamy bg-brand-creamy z-0 hidden md:block ${
                isAr ? "translate-x-12" : "-translate-x-12"
              }`}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
